'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { path } from '../../utils/iterables';
import { jsx as _jsx } from "react/jsx-runtime";
const getEmptyInfo = () => {
  return {
    ctaName: '',
    ctaGuid: undefined,
    ctaUrl: '',
    ctaError: undefined
  };
};
const withCtaInfo = WrappedComponent => {
  class CtaInfo extends Component {
    constructor(props) {
      super(props);
      this.clearCtaInfo = () => {
        this.setState(getEmptyInfo());
      };
      this.updateCtaInfo = data => {
        const {
          name,
          guid,
          ctaInfo = [],
          properties = []
        } = data;
        if (!guid) {
          // This is a web-interactive, which doesn't have an exposed url
          const ctaGuid = properties['hs_content_id'].value;
          const ctaName = properties['hs_name'].value;
          this.setState({
            ctaName,
            ctaGuid,
            ctaUrl: '',
            ctaError: null
          });
          return;
        }

        // fallback for multivariate cta w/ no default
        const defaultCtaInfo = ctaInfo.find(placement => !!placement.isDefault) || ctaInfo.find(placement => placement.variantLabel && !placement.disabled);
        if (!defaultCtaInfo) {
          // Throw an async error for app-level sentries
          setTimeout(() => {
            throw new Error(`CTA with guid '${guid}' has no ctaInfo`);
          });
        }
        this.setState({
          ctaName: name,
          ctaGuid: guid,
          ctaUrl: path(['url'], defaultCtaInfo),
          ctaError: null
        });
      };
      this.fetchCtaInfo = (guid, fetchCtaInfoCallback = () => {}) => {
        this.props.fetchCtaInfo(guid).then(data => {
          if (!data) {
            console.warn(`Could not fetch CTA with guid: ${guid}`);
          }
          fetchCtaInfoCallback(data);
          if (this.mounted) {
            this.updateCtaInfo(data);
          }
        }).catch(error => {
          console.warn(error.message);
          fetchCtaInfoCallback(error);
          if (this.mounted) {
            this.setState(Object.assign({}, getEmptyInfo(), {
              ctaError: error
            }));
          }
        });
      };
      this.mounted = false;
      this.state = getEmptyInfo();
    }
    componentDidMount() {
      this.mounted = true;
      const {
        fetchOnMount,
        ctaGuid
      } = this.props;
      if (fetchOnMount && ctaGuid) {
        this.fetchCtaInfo(ctaGuid);
      }
    }
    componentWillUnmount() {
      this.mounted = false;
    }
    render() {
      const {
        ctaName,
        ctaGuid,
        ctaUrl,
        ctaError
      } = this.state;
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        fetchCtaInfo: this.fetchCtaInfo,
        updateCtaInfo: this.updateCtaInfo,
        clearCtaInfo: this.clearCtaInfo,
        ctaName: ctaName,
        ctaGuid: ctaGuid,
        ctaUrl: ctaUrl,
        ctaError: ctaError
      }));
    }
  }
  CtaInfo.defaultProps = {
    fetchOnMount: false,
    ctaGuid: ''
  };
  CtaInfo.displayName = `CtaInfo(${getComponentName(WrappedComponent)})`;
  CtaInfo.propTypes = {
    fetchCtaInfo: PropTypes.func.isRequired,
    fetchOnMount: PropTypes.bool,
    ctaGuid: PropTypes.string
  };
  return CtaInfo;
};
export default withCtaInfo;